module.exports = __webpack_public_path__ + "img/filete_con_camarones.c3e4b4f4.jpg";